import React from 'react';

export default function SessionForm({ input, onChange, onJoin, onStop, sessionId, theme }) {
  return (
    <form onSubmit={onJoin} style={{ display: 'flex', gap: 8, justifyContent: 'center', marginBottom: 12 }}>
      <input
        style={inputStyle(theme)}
        placeholder="Session ID"
        maxLength={4}
        value={input}
        onChange={e => onChange(e.target.value)}
      />
      <button style={btnStyle(theme.accent)} type="submit">Join</button>
      {sessionId && (
        <button style={btnStyle(theme.danger)} type="button" onClick={onStop}>Stop</button>
      )}
    </form>
  );
}

function inputStyle(theme) {
  return {
    fontSize: 17, padding: '8px 14px', width: 150,
    letterSpacing: 6, textAlign: 'center',
    border: `1.5px solid ${theme.inputBorder}`,
    borderRadius: 8, outline: 'none',
    background: theme.inputBg, color: theme.text,
  };
}

function btnStyle(bg) {
  return {
    fontSize: 15, padding: '8px 22px',
    background: bg, color: '#fff',
    border: 'none', borderRadius: 8,
    cursor: 'pointer', fontWeight: 600,
  };
}
